
// import { useState, useRef, useCallback, useEffect } from "react";

// // ── Language map ─────────────────────────────────────────
// export const LANG_MAP = {
//   en: "en-US",
//   hi: "hi-IN",
//   te: "te-IN",
//   ta: "ta-IN",
// };

// const SpeechRecognition =
//   typeof window !== "undefined"
//     ? window.SpeechRecognition || window.webkitSpeechRecognition
//     : null;

// export const isSpeechSupported = !!SpeechRecognition;

// export default function useVoiceChat({
//   lang,
//   autoSend = true,
//   silenceMs = 1800,
//   onSendText,
// }) {
//   const [micState, setMicState] = useState("idle");
//   const [liveText, setLiveText] = useState("");
//   const [isSpeaking, setIsSpeaking] = useState(false);
//   const [micError, setMicError] = useState("");

//   const recognizerRef = useRef(null);
//   const finalBufferRef = useRef("");
//   const silenceTimerRef = useRef(null);

//   const bcp47 = LANG_MAP[lang] || "en-US";

//   useEffect(() => {
//     return () => {
//       stopListening();
//       window.speechSynthesis?.cancel();
//     };
//   }, []);

//   // ── Stop recognition ───────────────────────────────────
//   const stopListening = useCallback((andSend = false) => {
//     clearTimeout(silenceTimerRef.current);

//     if (recognizerRef.current) {
//       recognizerRef.current._stopped = true;
//       recognizerRef.current.onend = null;
//       recognizerRef.current.stop();
//       recognizerRef.current = null;
//     }

//     setMicState("idle");

//     if (andSend) {
//       const text = finalBufferRef.current.trim();
//       if (text) onSendText?.(text);
//       finalBufferRef.current = "";
//       setLiveText("");
//     }
//   }, [onSendText]);

//   // ── Silence timer ──────────────────────────────────────
//   const resetSilenceTimer = () => {
//     if (!autoSend) return;

//     clearTimeout(silenceTimerRef.current);
//     silenceTimerRef.current = setTimeout(() => {
//       if (finalBufferRef.current.trim()) {
//         stopListening(true);
//       }
//     }, silenceMs);
//   };

//   // ── Start listening ────────────────────────────────────
//   const startListening = useCallback(() => {
//     if (!SpeechRecognition) return;

//     stopSpeaking();
//     setMicError("");
//     finalBufferRef.current = "";
//     setLiveText("");

//     const rec = new SpeechRecognition();
//     rec.lang = bcp47;
//     rec.continuous = true;
//     rec.interimResults = true;

//     let restartCount = 0;
//     const MAX_RESTARTS = 5;

//     rec.onstart = () => setMicState("listening");

//     rec.onresult = (event) => {
//       let interim = "";
//       let final = "";

//       for (let i = event.resultIndex; i < event.results.length; i++) {
//         const chunk = event.results[i][0].transcript;

//         if (event.results[i].isFinal) final += chunk + " ";
//         else interim += chunk;
//       }

//       if (final) {
//         finalBufferRef.current += final;
//         resetSilenceTimer();
//       }

//       if (interim) resetSilenceTimer(); // 🔥 important improvement

//       setLiveText((finalBufferRef.current + interim).trim());
//     };

//     rec.onerror = (e) => {
//       if (e.error === "no-speech") return;

//       setMicError(
//         e.error === "not-allowed"
//           ? "Microphone permission denied."
//           : `Error: ${e.error}`
//       );

//       setMicState("idle");
//     };

//     rec.onend = () => {
//       if (rec._stopped || restartCount > MAX_RESTARTS) return;
//       restartCount++;
//       try {
//         rec.start();
//       } catch {}
//     };

//     recognizerRef.current = rec;

//     try {
//       rec.start();
//     } catch {
//       setMicState("idle");
//     }
//   }, [bcp47]);

//   const toggleMic = useCallback(() => {
//     if (micState === "listening") stopListening(true);
//     else startListening();
//   }, [micState, startListening, stopListening]);

//   const speak = useCallback((text) => {
//   if (!window.speechSynthesis || !text?.trim()) return;

//   window.speechSynthesis.cancel();

//   const utter = new SpeechSynthesisUtterance(text);

//   //  Language
//   utter.lang = bcp47;

//   //  Slow + soft tuning
//   utter.rate = 0.7;     // slower (0.7–0.85 ideal)
//   utter.pitch = 1.1;    // slightly soft feminine tone
//   utter.volume = 1;

//   const trySpeak = () => {
//     const voices = window.speechSynthesis.getVoices();
//     const langCode = bcp47.split("-")[0];

//     //  PRIORITY ORDER (important)
//     const preferredVoice =
//       // 1. Indian Female voices (BEST)
//       voices.find(v =>
//         v.lang.includes("IN") &&
//         (
//           v.name.toLowerCase().includes("female") ||
//           v.name.toLowerCase().includes("google") ||
//           v.name.toLowerCase().includes("samantha") ||   // iOS Indian female
//           v.name.toLowerCase().includes("veena") ||      // some Android
//           v.name.toLowerCase().includes("lekha")
//         )
//       ) ||

//       // 2. Any female voice in same language
//       voices.find(v =>
//         v.lang.startsWith(langCode) &&
//         (
//           v.name.toLowerCase().includes("female") ||
//           v.name.toLowerCase().includes("woman")
//         )
//       ) ||

//       // 3. Google voices (usually smooth)
//       voices.find(v =>
//         v.lang.startsWith(langCode) &&
//         v.name.toLowerCase().includes("google")
//       ) ||

//       // 4. Any Indian voice
//       voices.find(v => v.lang.includes("IN")) ||

//       // 5. Fallback
//       voices.find(v => v.lang.startsWith(langCode));

//     if (preferredVoice) {
//       utter.voice = preferredVoice;
//     }

//     utter.onstart = () => setIsSpeaking(true);
//     utter.onend = () => setIsSpeaking(false);
//     utter.onerror = () => setIsSpeaking(false);

//     window.speechSynthesis.speak(utter);
//   };

//   if (window.speechSynthesis.getVoices().length) {
//     trySpeak();
//   } else {
//     window.speechSynthesis.onvoiceschanged = () => {
//       trySpeak();
//       window.speechSynthesis.onvoiceschanged = null;
//     };
//   }
// }, [bcp47]);

//   const stopSpeaking = useCallback(() => {
//     window.speechSynthesis?.cancel();
//     setIsSpeaking(false);
//   }, []);

//   return {
//     micState,
//     liveText,
//     isSpeaking,
//     micError,
//     isListening: micState === "listening",
//     toggleMic,
//     startListening,
//     stopListening,
//     speak,
//     stopSpeaking,
//     isSpeechSupported,
//   };
// }
import { useState, useRef, useCallback, useEffect } from "react";

// ── Language map ─────────────────────────────────────────────────────────────
export const LANG_MAP = {
  en: "en-IN",   // Indian English — better accent for Indian users
  hi: "hi-IN",
  te: "te-IN",
  ta: "ta-IN",
  kn: "kn-IN",
  ml: "ml-IN",
  mr: "mr-IN",
  gu: "gu-IN",
  bn: "bn-IN",
  pa: "pa-IN",
};

const SpeechRecognition =
  typeof window !== "undefined"
    ? window.SpeechRecognition || window.webkitSpeechRecognition
    : null;

export const isSpeechSupported = !!SpeechRecognition;

// ── Voice scoring: higher = more preferred ───────────────────────────────────
function scoreVoice(voice, bcp47) {
  const name = voice.name.toLowerCase();
  const lang = voice.lang.toLowerCase();
  const bcp = bcp47.toLowerCase();
  const [langCode, regionCode] = bcp.split("-");
  let score = 0;

  // Must match language at minimum
  if (!lang.startsWith(langCode)) return -1;

  // Exact locale match (e.g. hi-IN)
  if (lang === bcp) score += 40;
  else if (lang.startsWith(langCode)) score += 10;

  // Prefer Indian region
  if (lang.includes("in")) score += 20;

  // Prefer female / soft voices
  const femaleKeywords = [
    "female", "woman", "girl", "lekha", "veena", "raveena",
    "aditi", "priya", "sunita", "kavya", "meera", "ananya",
    "heera", "tanvee", "samantha", "moira", "tessa", "karen",
  ];
  if (femaleKeywords.some((k) => name.includes(k))) score += 30;

  // Prefer Google voices (usually best quality)
  if (name.includes("google")) score += 15;

  // Prefer Microsoft Neural voices
  if (name.includes("neural") || name.includes("online")) score += 10;

  // Avoid male-labelled voices
  const maleKeywords = ["male", "man", "boy", "david", "james", "george", "rishi"];
  if (maleKeywords.some((k) => name.includes(k))) score -= 40;

  return score;
}

function getBestVoice(bcp47) {
  const voices = window.speechSynthesis.getVoices();
  if (!voices.length) return null;

  const scored = voices
    .map((v) => ({ voice: v, score: scoreVoice(v, bcp47) }))
    .filter((v) => v.score >= 0)
    .sort((a, b) => b.score - a.score);

  return scored[0]?.voice || null;
}

export default function useVoiceChat({
  lang,
  autoSend = true,
  silenceMs = 1800,
  onSendText,
}) {
  const [micState, setMicState] = useState("idle"); // "idle" | "listening"
  const [liveText, setLiveText] = useState("");
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [micError, setMicError] = useState("");

  const recognizerRef = useRef(null);
  const finalBufferRef = useRef("");
  const silenceTimerRef = useRef(null);
  const voicesCachedRef = useRef(null); // cache after first load

  const bcp47 = LANG_MAP[lang] || "en-IN";

  // Pre-load voices as early as possible
  useEffect(() => {
    const preload = () => {
      const voices = window.speechSynthesis.getVoices();
      if (voices.length) voicesCachedRef.current = voices;
    };
    preload();
    window.speechSynthesis.onvoiceschanged = () => {
      preload();
      window.speechSynthesis.onvoiceschanged = null;
    };
    return () => {
      stopListening();
      window.speechSynthesis?.cancel();
    };
  }, []);

  // ── Stop recognition ─────────────────────────────────────────────────────
  const stopListening = useCallback(
    (andSend = false) => {
      clearTimeout(silenceTimerRef.current);

      if (recognizerRef.current) {
        recognizerRef.current._stopped = true;
        recognizerRef.current.onend = null;
        recognizerRef.current.stop();
        recognizerRef.current = null;
      }

      setMicState("idle");

      if (andSend) {
        const text = finalBufferRef.current.trim();
        if (text) onSendText?.(text);
        finalBufferRef.current = "";
        setLiveText("");
      }
    },
    [onSendText]
  );

  // ── Silence timer ────────────────────────────────────────────────────────
  const resetSilenceTimer = useCallback(() => {
    if (!autoSend) return;
    clearTimeout(silenceTimerRef.current);
    silenceTimerRef.current = setTimeout(() => {
      if (finalBufferRef.current.trim()) {
        stopListening(true);
      }
    }, silenceMs);
  }, [autoSend, silenceMs, stopListening]);

  // ── Start recognition ────────────────────────────────────────────────────
  const startListening = useCallback(() => {
    if (!SpeechRecognition) return;

    stopSpeaking();
    setMicError("");
    finalBufferRef.current = "";
    setLiveText("");

    const rec = new SpeechRecognition();
    rec.lang = bcp47;
    rec.continuous = true;
    rec.interimResults = true;
    rec.maxAlternatives = 1;

    let restartCount = 0;
    const MAX_RESTARTS = 5;

    rec.onstart = () => setMicState("listening");

    rec.onresult = (event) => {
      let interim = "";
      let final = "";

      for (let i = event.resultIndex; i < event.results.length; i++) {
        const chunk = event.results[i][0].transcript;
        if (event.results[i].isFinal) final += chunk + " ";
        else interim += chunk;
      }

      if (final) {
        finalBufferRef.current += final;
        resetSilenceTimer();
      }
      if (interim) resetSilenceTimer();

      setLiveText((finalBufferRef.current + interim).trim());
    };

    rec.onerror = (e) => {
      if (e.error === "no-speech") return;
      setMicError(
        e.error === "not-allowed"
          ? "Microphone permission denied."
          : `Error: ${e.error}`
      );
      setMicState("idle");
    };

    rec.onend = () => {
      if (rec._stopped || restartCount >= MAX_RESTARTS) return;
      restartCount++;
      try { rec.start(); } catch {}
    };

    recognizerRef.current = rec;
    try { rec.start(); } catch { setMicState("idle"); }
  }, [bcp47, resetSilenceTimer]);

  const toggleMic = useCallback(() => {
    if (micState === "listening") stopListening(true);
    else startListening();
  }, [micState, startListening, stopListening]);

  // ── Speak ────────────────────────────────────────────────────────────────
  const speak = useCallback(
    (text) => {
      if (!window.speechSynthesis || !text?.trim()) return;

      window.speechSynthesis.cancel();

      const utter = new SpeechSynthesisUtterance(text);
      utter.lang = bcp47;

      // Calm, slow, soft settings
      utter.rate   = 1.5;  // noticeably slower than default (1.0)
      utter.pitch  = 1.05;  // very slightly higher — soft feminine
      utter.volume = 1;

      const trySpeak = () => {
        const bestVoice = getBestVoice(bcp47);
        if (bestVoice) utter.voice = bestVoice;

        utter.onstart = () => setIsSpeaking(true);
        utter.onend   = () => setIsSpeaking(false);
        utter.onerror = () => setIsSpeaking(false);

        window.speechSynthesis.speak(utter);
      };

      if (window.speechSynthesis.getVoices().length) {
        trySpeak();
      } else {
        window.speechSynthesis.onvoiceschanged = () => {
          trySpeak();
          window.speechSynthesis.onvoiceschanged = null;
        };
      }
    },
    [bcp47]
  );

  const stopSpeaking = useCallback(() => {
    window.speechSynthesis?.cancel();
    setIsSpeaking(false);
  }, []);

  // ── Speak multiple messages sequentially ─────────────────────────────────
  const speakAll = useCallback(
    async (messages) => {
      stopSpeaking();

      for (const msg of messages) {
        if (msg.text?.trim()) {
          await new Promise((resolve) => {
            if (!window.speechSynthesis) return resolve();

            const utter = new SpeechSynthesisUtterance(msg.text);
            utter.lang   = bcp47;
            utter.rate   = 0.78;
            utter.pitch  = 1.05;
            utter.volume = 1;

            const bestVoice = getBestVoice(bcp47);
            if (bestVoice) utter.voice = bestVoice;

            utter.onstart = () => setIsSpeaking(true);
            utter.onend   = () => { setIsSpeaking(false); resolve(); };
            utter.onerror = () => { setIsSpeaking(false); resolve(); };

            window.speechSynthesis.speak(utter);
          });
        }

        if (msg.buttons?.length) {
          const optionsText = msg.buttons.map((b) => b.title).join(", ");
          await new Promise((resolve) => {
            const utter = new SpeechSynthesisUtterance(`Options: ${optionsText}`);
            utter.lang   = bcp47;
            utter.rate   = 0.78;
            utter.pitch  = 1.05;
            utter.volume = 1;

            const bestVoice = getBestVoice(bcp47);
            if (bestVoice) utter.voice = bestVoice;

            utter.onend   = () => resolve();
            utter.onerror = () => resolve();
            window.speechSynthesis.speak(utter);
          });
        }
      }
    },
    [bcp47, stopSpeaking]
  );

  return {
    micState,
    liveText,
    isSpeaking,
    micError,
    isListening: micState === "listening",
    toggleMic,
    startListening,
    stopListening,
    speak,
    speakAll,
    stopSpeaking,
    isSpeechSupported,
  };
}